<template>
  <div class="mapView">
    <div class="county-span">
      <div
        v-for="(item, index) in countyList"
        :key="index"
        @click="changeXzqh(index)"
        :class="[item.is_check ? 'active-span' : '', 'gesture']"
      >
        <span v-if="index != 0" class="county-span-g"> /</span> {{ item.label }}
      </div>
    </div>

    <div class="box">
      <!-- <button class="backBtn" @click="back()">返回上级</button> -->
      <div ref="mapdd" id="mapdd" class="chart"></div>
    </div>
  </div>
</template>
<script>
import cityMap from "./js/yunnan-city"; //展示每个省的id
import * as echarts from "echarts";
import axios from "axios";
// import { getPoint } from "/@/api/homeApi";
import { getCode, getValue, divisionCode } from "@/api/common/index";
//中国地图（第一级地图）的ID、Name、Json数据
// var chinaId = 100000;
// var chinaName = "china";
var chinaId = 530000;
var chinaName = "yunnan";
var chinaJson = null;
var areaCode = null; //区县级code
var areaName = "东川区";
//记录父级ID、Name
var mapStack = [];
var parentId = null;
var parentName = null;

//Echarts地图全局变量，主要是在返回上级地图的方法中会用到
var myChart = null;
var aaa = "111";
export default {
  name: "chinaMap",
  props: {
    countyCurrent: {
      type: String,
      default: "53",
    },
    // countyList: {
    //   type: Array,
    //   default: () => {
    //     return [{ value: 53, label: "云南省", is_check: true }];
    //   },
    // },
  },
  data() {
    return {
      radio: "全部应用",
      mapDate6: [],
      county: "",
      countyList: [{ value: 53, label: "云南省", is_check: true }],
    };
  },
  watch: {
    county: {
      handler(val) {
        if (val) {
          let str = val;
          let len = val.length;
          if (len == 2) {
            str = str + "0000";
            areaCode = null;
            this.mapChart();
          }
          if (len == 4) {
            str = str + "00";
            areaCode = null;
          }
          if (len == 6) {
            str = str.slice(0, 4) + "00";

            areaCode = val;
            getCode({ value: val }).then((res) => {
              if (res.data.success && res.data.data) {
                areaName = res.data.data;
                chinaId = Number(str);
                this.mapChart();
              }
            });
          }
          if (len != 6) {
            chinaId = Number(str);
            this.mapChart();
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    //页面刷新时重新复赋值
    this.county = this.countyCurrent;
    //this.getData();
  },
  mounted() {
    // this.mapChart();
    //innerWidth
    // let initializeWidth = window.screen.width; //初始化网页宽度
    // if (initializeWidth < 1800) {
    //   this.mapddDom = document.getElementById("mapdd");
    //   this.mapddDom.style.zoom = "1.25";
    // }
  },
  methods: {
    getData() {
      divisionCode({ divisionCode: "53" }).then((res) => {
        if (res.data.success) {
          let data = [];
          res.data.data.forEach((item) => {
            data.push({ name: item.name, value: item.value });
          });
          this.mapDataValue = data;
        }
      });
    },
    changeXzqh(index) {
      if (index == 0) {
        let len = this.countyList.length;
        this.countyList[0].is_check = true;
        this.county = this.countyList[0].value;
        this.countyList.splice(1, len - (index + 1));
        this.$emit("callBackCounty", this.county);
        return false;
      }
      this.countyList.splice(index + 1, 1);
      let len = this.countyList.length;
      this.countyList[len - 1].is_check = true;
      this.county = this.countyList[index].value;
      this.$emit("callBackCounty", this.county);
      // this.$emit("callBackXzqh", this.county);
    },

    //这是接口获取点位坐标 返回的是经纬度的
    // getallpoints(param) {
    //   let res = getPoint({
    //     ...param,
    //   });
    //   res.then((res) => {
    //     this.mapDate6 = res.data;
    //     this.mapDate6.forEach((item)=>{
    //       item.name = item.province
    //     })
    //     this.mapChart();//获取数据成功构建地图
    //   }).catch(()=>{
    //     this.mapChart();//如果没有网络也让构建地图
    //   });
    // },

    // 返回上一级地图
    back() {
      if (mapStack.length != 0) {
        //如果有上级目录则执行
        var map = mapStack.pop();
        axios
          .get(systemConfig.mapJsonUrl + map.mapId + ".json", {})
          .then((response) => {
            const mapJson = response.data;
            this.getecharts(myChart, map.mapId, map.mapName, mapJson, false);
            parentId = map.mapId;
            parentName = map.mapName;
          });
      }
    },
    //获取本地地图信息
    mapChart() {
      axios
        .get(systemConfig.mapJsonUrl + chinaId + ".json")
        .then((response) => {
          const mapJson = response.data;
          chinaJson = mapJson;
          myChart = echarts.init(document.getElementById("mapdd"));
          this.getecharts(myChart, chinaId, chinaName, mapJson, false);
          parentId = chinaId;
          parentName = "yunnan";
          myChart.off("click");
          myChart.on("click", (param) => {
            var cityId = cityMap[param.name];
            if (cityId) {
              //代表有下级地图
              axios
                .get(systemConfig.mapJsonUrl + cityId + ".json", {})
                .then((response) => {
                  const mapJson = response.data;
                  this.getecharts(myChart, cityId, param.name, mapJson, true);
                });
              let str = cityMap[param.name].slice(0, 4);
              this.countyList = [
                { value: "53", label: "云南省", is_check: false },
                { value: str, label: param.name, is_check: true },
              ];
              this.$emit("changeCounty", this.countyList);
              this.$emit("callBackCounty", str);
              this.county = cityId;
            } else {
              this.getCountyCode(param.name);
            }
          });
          // myChart.on("mouseover", function (params) {
          //   console.log(params); //这里的params是鼠标悬浮的图表节点的数据
          // });
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        })
        .catch((res) => {
          // console.log("错误信息", res);
        });
    },

    //获取行政区划code
    getCountyCode(val) {
      getValue({ label: val }).then((res) => {
        if (res.data.success && res.data.data) {
          this.$emit("callBackCounty", res.data.data);
          this.countyList.forEach((item) => {
            item.is_check = false;
          });
          if (this.countyList.length == 2) {
            this.countyList.push({
              value: res.data.data,
              label: val,
              is_check: true,
            });
          }
          if (this.countyList.length == 3) {
            this.countyList.splice(2, 1);
            this.countyList.push({
              value: res.data.data,
              label: val,
              is_check: true,
            });
          }
          this.$emit("changeCounty", this.countyList);
        }
      });
    },

    //echarts构建地图和点位信息
    getecharts(myChart, id, name, mapJson, flag) {
      echarts.registerMap(name, { geoJSON: mapJson });
      divisionCode({ divisionCode: id }).then((res) => {
        if (res.data.success) {
          let data = [];
          res.data.data.forEach((item) => {
            data.push({
              name: item.name,
              value: item.value,
              value1: item.value1,
            });
          });
          let options = {
            tooltip: {
              trigger: "item",
              color: "#000",
              formatter: (param) => {
                return `区域：${param.data.name}<br/>地块：${param.data.value} 宗<br/>招商项目：${param.data.value1}个`;
              },
            },
            // label: {
            //   show: true,
            // },
            visualMap: {
              text: ["高", "低"], //两端的文本
              min: 0,
              max: 25,
              realtime: false,
              calculable: false,
              inRange: {
                color: ["#c5d4fa", "#376ef0"],
              },
              left: 20,
              show: false,
            },
            geo: {
              map: name,
              roam: false,
              label: {
                show: true,
                // emphasis: {
                //   show: true,
                // },
                align: "center",
                verticalAlign: "top",
                formatter: function (param) {
                  if (param.name == "大理白族自治州") {
                    return "大理州";
                  }
                  if (param.name == "德宏傣族景颇族自治州") {
                    return "德宏州";
                  }
                  if (param.name == "西双版纳傣族自治州") {
                    return "西双版纳州";
                  }
                  if (param.name == "文山壮族苗族自治州") {
                    return "文山州";
                  }
                  if (param.name == "红河哈尼族彝族自治州") {
                    return "红河州";
                  }
                  if (param.name == "楚雄彝族自治州") {
                    return "楚雄州";
                  }
                  if (param.name == "怒江傈僳族自治州") {
                    return "怒江州";
                  }
                  if (param.name == "迪庆藏族自治州") {
                    return "迪庆州";
                  }
                },
              },
              zoom: 1.2,
              aspectScale: 1,
            },
            series: [
              {
                geoIndex: 0,
                name: "地域分布",
                type: "map",
                coordinateSystem: "geo",
                map: name,
                data: data,
                layoutCenter: ["50%", "80%"], //地图位置

                // tooltip: {
                //   trigger: "item",
                //   formatter: function (params, ticket, callback) {
                //     console.log(params, "========");
                //   },
                // },
              },
            ],
          };
          myChart.setOption(options);
        }
      });
      window.addEventListener("resize", function () {
        echarts.resize();
      });
      let data = [
        {
          name: "昆明市",
          value: 1,
        },
        {
          name: "曲靖市",
          value: 25,
        },
        {
          name: "玉溪市",
          value: 0,
        },
        {
          name: "昭通市",
          value: 0,
        },
        {
          name: "楚雄彝族自治州",
          value: 0,
        },
        {
          name: "红河哈尼族彝族自治州",
          value: 0,
        },
        {
          name: "文山壮族苗族自治州",
          value: 0,
        },
        {
          name: "西双版纳傣族自治州",
          value: 0,
        },
        {
          name: "大理白族自治州",
          value: 0,
        },
        {
          name: "保山市",
          value: 0,
        },
        {
          name: "德宏傣族景颇族自治州",
          value: 0,
        },
        {
          name: "丽江市",
          value: 0,
        },
        {
          name: "怒江傈僳族自治州",
          value: 0,
        },
        {
          name: "迪庆藏族自治州",
          value: 0,
        },
        {
          name: "临沧市",
          value: 0,
        },
        {
          name: "普洱市",
          value: 0,
        },
      ];
    },

    initmapdata(mapJson) {
      var mapData = [];
      for (var i = 0; i < mapJson.features.length; i++) {
        let obj = { name: mapJson.features[i].properties.name };
        if (
          areaCode &&
          areaName &&
          mapJson.features[i].properties.name == areaName
        ) {
          this.$set(obj, "selected", true);
        }
        mapData.push(obj);
      }
      return mapData;
    },
  },
};
</script>
<style scoped>
.mapView {
  position: relative;
  width: 100%;
  height: 100%;
  /* box-shadow: inset 0px 1px 7px 0px #dddddd; */
}
.box {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
}
.chart {
  width: 100%;
  height: 100%;
  /* height: calc(100% - 29px); */
}
.county-span-g {
  padding: 0 3px;
}
.county-span {
  /* margin-bottom: 10px;
  padding-left: 10px; */
  font-size: 0.85rem;
  display: flex;
  font-weight: bold;
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
}
.gesture {
  cursor: pointer;
}
.active-span {
  color: #2785de;
}
</style>